import { useEffect } from "react";

interface MetaTagsProps {
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogUrl?: string;
  ogType?: string;
  robots?: "noindex, nofollow";
}

function setMeta(attrName: string, attrValue: string, content: string) {
  const selector = `meta[${attrName}="${attrValue}"]`;
  let el = document.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
  return el;
}

function removeMeta(attrName: string, attrValue: string) {
  document.querySelector(`meta[${attrName}="${attrValue}"]`)?.remove();
}

export function MetaTags({
  description,
  ogTitle,
  ogDescription,
  ogImage,
  ogUrl,
  ogType,
  robots,
}: MetaTagsProps) {
  useEffect(() => {
    if (description) setMeta("name", "description", description);
    if (ogTitle) setMeta("property", "og:title", ogTitle);
    if (ogDescription) setMeta("property", "og:description", ogDescription);
    if (ogImage) setMeta("property", "og:image", ogImage);
    if (ogUrl) setMeta("property", "og:url", ogUrl);
    if (ogType) setMeta("property", "og:type", ogType);
    if (robots) setMeta("name", "robots", robots);

    return () => {
      if (robots) removeMeta("name", "robots");
    };
  }, [description, ogTitle, ogDescription, ogImage, ogUrl, ogType, robots]);

  return null;
}
